import React, { useState, useEffect } from 'react';
import { Icon, Text } from 'porosys-ui';
import { getUserNotifications, markNotificationAsSeen } from '../api';
import { Link } from 'react-router-dom';
import moment from 'moment-jalaali';
import '../styles.scss';

const NotificationList = props => {
    const { onMarkedAsSeenTrigger } = props;
    const [notifications, setNotifications] = useState([]);

    useEffect(() => {
        const fetchNotifications = async () => {
            setNotifications(await getUserNotifications());
        };

        fetchNotifications();
    }, []);

    const localizeDate = date => {
        return moment(date).format('jYYYY/jMM/jDD HH:mm:ss');
    };
    const handleMarkNotificationAsSeen = notificationId => {
        markNotificationAsSeen(notificationId);
        const remainingNotifications = notifications.filter(notification => {
            return notification._id !== notificationId;
        });
        onMarkedAsSeenTrigger();
        setNotifications(remainingNotifications);
    };

    return (
        <div className="notifications-list">
            {notifications.length > 0
                ? notifications.map((notification, i) => (
                      <div key={i} className="notification-card">
                          <Text classes={{ root: 'notification-text' }} variant="subtitle2">
                              {notification.title}
                              <br />
                              <span className="text-muted notification-date">
                                  {localizeDate(notification.createdAt)}
                              </span>{' '}
                          </Text>
                          <Link
                              to={`/${notification.documentName}/${notification.documentId}`}
                              onClick={() => {
                                  handleMarkNotificationAsSeen(notification._id);
                              }}
                              className="toggle-notification-btn"
                          >
                              <Icon name="angleLeft" />
                          </Link>
                      </div>
                  ))
                : 'اطلاعاتی وجود ندارد'}
        </div>
    );
};

export default NotificationList;
